//@ts-nocheck
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

export const fetchItems = createAsyncThunk(
  'items/fetchItems',
  async (payload) => {
    const response = await axiosInstance.post(`${BASE_URL}/api/v1/FoodProgram/GetFoodProgramItemList`,payload);
    return response.data.data.foodprogramitems;
  }
);

type initialState = {
  items: object[],
  loading: boolean,
  error: null | string,
}

// Initial state
const initialState: any = {
  items: [],
  loading: false,
  error: null,
};


// Create the slice
const itemsSlice = createSlice({
  name: 'items',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchItems.pending, (state) => {
        state.loading = true;
        state.error = null; // Reset error on new fetch
      })
      .addCase(fetchItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch dishes';
      });
  },
});

export default itemsSlice.reducer;
